import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { world_map } from './world-map';
import { ScheduleService } from '../../schedules/schedule.service';
import { MatDialog } from '@angular/material/dialog';
import { ModalComponent } from '../../schedules/map-view/modal.component'
import { TabComponent } from '@syncfusion/ej2-angular-navigations';
@Component({
  selector: 'app-map-view',
  standalone: false,

  templateUrl: './map-view.component.html',
  styleUrl: './map-view.component.css'
})
export class MapViewComponent implements OnInit, AfterViewInit {

  @ViewChild('element') tab!: TabComponent;
  public shapeData: object = world_map;

  public zoomSettings = {
    enable: true,
    zoomFactor: 13,
    maxZoom: 25,
    toolbarSettings: {
      orientation: 'Horizontal',
      verticalAlignment: 'Near',
      buttonSettings: {
        toolbarItems: ['Zoom', 'ZoomIn', 'ZoomOut', 'Pan', 'Reset'],
      },
    },
    mouseWheelZoom: true
  };

  public schedules: any[] = [];
  public criteria = { offset: 0, limit: 10, sortBy: 'date', sortOrder: 'ASC' };

  constructor(private scheduleService: ScheduleService, public dialog: MatDialog) { }

  ngOnInit(): void {
    //this.loadSchedules();
  }

  ngAfterViewInit(): void { }

  loadSchedules(): void {
    this.scheduleService.getSchedules(this.criteria).subscribe({
      next: (data) => {
        this.schedules = data.results; // Store the fetched schedules
      },
      error: (error) => {
        console.error('Error fetching schedules:', error);
      }
    });
  }

  // Detect tab selection using click event
  checkTabSelection() {
    if (this.tab?.selectedItem === 0) { // Check if "API Data Subscription" is active
      this.openModal();
    }
  }

  openModal() {
    this.dialog.open(ModalComponent, {
      width: '600px',
      height: 'auto',
      data: { message: "Manage Hangfire Jobs" }
    });
  }
}



